export const availabilityPreferencesQueryKeys = {
  all: ['availability-preferences'] as const,
  detail: (userId: string | undefined) =>
    [...availabilityPreferencesQueryKeys.all, userId] as const,
};
